const initialState: any = {
  loading: false,
  editItemsData: [],
  error: '',
};

export const itemEditReducer = (state = initialState, action: any): any => {
  switch (action.type) {
    case 'EDIT_ITEMS':
      return {
        ...state,
        editItemsData: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};
